import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SalaryRule } from 'src/app/classes/salary-rule';
import { SalaryRuleRuleset } from 'src/app/classes/salary-rule-ruleset';
import { SettingsService } from 'src/app/services/settings.service';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import salaryRuleRulesetRuleType from 'src/app/constants/salary-rule-ruleset-rule-type';
import { Organization } from 'src/app/classes/organization';
import { forkJoin } from 'rxjs';
import citySelectorType from 'src/app/constants/salary-rule-city-selectors';

@Component({
  selector: 'app-salary-rules',
  templateUrl: './salary-rules.component.html',
  styleUrls: ['./salary-rules.component.scss'],
  providers: [DatePipe]
})
export class SalaryRulesComponent implements OnInit {
  salaryRulesId!: number;
  salaryRules = new SalaryRule();
  selectedRuleset: SalaryRuleRuleset | null = null;
  salaryRuleRulesetRuleType = salaryRuleRulesetRuleType
  organization!: Organization
  citySelectorType = citySelectorType

  constructor(
    public activeModal: NgbActiveModal, 
    private settingsService: SettingsService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    forkJoin({
      organization: this.settingsService.organizationPublic(),
      salaryRules: this.settingsService.salaryRules(this.salaryRulesId)
    }).subscribe({
      next: (response) => {
        this.organization = response.organization;
        this.salaryRules = response.salaryRules;
        if (this.salaryRules.rulesets && this.salaryRules.rulesets.length > 0) {
          this.selectedRuleset = this.salaryRules.rulesets[0];
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      }
    });
  }

  getActiveDays(rule: any): string {
    if (rule.monday && rule.tuesday && rule.wednesday && rule.thursday && 
        rule.friday && rule.saturday && rule.sunday) {
      return $localize`Any day`;
    }

    const days = [];
    if (rule.monday) days.push($localize`Mon`);
    if (rule.tuesday) days.push($localize`Tue`); 
    if (rule.wednesday) days.push($localize`Wed`);
    if (rule.thursday) days.push($localize`Thu`);
    if (rule.friday) days.push($localize`Fri`);
    if (rule.saturday) days.push($localize`Sat`);
    if (rule.sunday) days.push($localize`Sun`);
    return days.join(', ');
  }

}
